/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import {
    FETCH_RATING_REQUEST, FETCH_RATING_SUCCESS, FETCH_RATING_FAILURE, POST_RATING_REQUEST,
    POST_RATING_SUCCESS, POST_RATING_FAILURE, RatingActions
} from '../types/rating';

const initialState = {
    loading: true,
    ratings: {},
    error: ''
}

const ratingsReducer = (state = initialState, action: RatingActions) => {
    switch (action.type) {
        case FETCH_RATING_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_RATING_SUCCESS:
            return {
                ...state,
                loading: false,
                ratings: action.payload,
                error: ''
            }
        case FETCH_RATING_FAILURE:
            return {
                ...state,
                loading: true,
                ratings: {},
                error: action.payload
            }
        case POST_RATING_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case POST_RATING_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case POST_RATING_FAILURE:
            return {
                ...state,
                loading: true,
                error: action.payload
            }
        default: return state
    }
}

export default ratingsReducer;
